import { render } from "./DocumentosPaciente.vue?vue&type=template&id=10889072&scoped=true"
import script from "./DocumentosPaciente.vue?vue&type=script&lang=js"
export * from "./DocumentosPaciente.vue?vue&type=script&lang=js"

import "./DocumentosPaciente.vue?vue&type=style&index=0&id=10889072&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10889072"]])

export default __exports__